export const LOG_PROJECT = 'fuxi-fe-log'
export const LOG_STORE_NAME = 'saas-m'
export const LOG_REQ_URL = `https://${LOG_PROJECT}.cn-beijing.log.aliyuncs.com/logstores/${LOG_STORE_NAME}/track?APIVersion=0.6.0`
export const LOG_PLATFORM = ['fuxi','fulufuxi','juyoufuli']
export const LOG_ENV = ['prod','production']